// extracted by mini-css-extract-plugin
export default {"defaultCoverImage":"DefaultCoverImage_defaultCoverImage__bjTr+"};